import { SxProps } from '@mui/material';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import _, { PropsWithChildren } from 'react';
import { NavLink } from 'react-router-dom';

export type ActionHandler = () => void;

interface Props {
  sx?: SxProps;
  header: string;
  message1: string;
  message2?: string;
  actionLabel: string;
  action?: string | ActionHandler;
}

const InfoPage = (props: PropsWithChildren<Props>) => {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        height: '100%',
        paddingTop: 12,
        ...props.sx,
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          marginTop: 40,
          width: 440,
          paddingTop: 12,
        }}
      >
        <Box
          sx={{
            textAlign: 'center',
          }}
        >
          <Typography color="primary" variant="h4">
            {props.header}
          </Typography>
        </Box>
        <Paper
          sx={{
            padding: 36,
            paddingTop: 8,
            marginTop: 8,
          }}
          elevation={1}
        >
          <Typography
            sx={{
              marginTop: 24,
              color: '#6d6e70',
              textAlign: 'center',
            }}
            variant="body1"
          >
            {props.message1}
          </Typography>
          {typeof props.action === 'string' ? (
            <NavLink to={props.action}>
              <Button
                sx={{
                  marginTop: 24,
                }}
                color="primary"
                variant="contained"
                fullWidth
              >
                {props.actionLabel}
              </Button>
            </NavLink>
          ) : (
            <Button
              sx={{
                marginTop: 24,
              }}
              color="primary"
              variant="contained"
              fullWidth
              onClick={props.action}
            >
              {props.actionLabel}
            </Button>
          )}
        </Paper>
      </Box>
    </Box>
  );
};

export default InfoPage;
